module.exports = __webpack_public_path__ + "img/telegram.de9a0fa9.svg";